
import React, { Component } from 'react';
import logo from '../imgs/et2logo.png';
import {Table} from 'antd';
// import './Base.css';
import {historyPush} from '../utils/Util';
import './ViewResult.css';

class ViewResult extends Component {
    render() {
        const dataSource = [{
            key: 'Question 1',
            answer: 'Answer',
            unanswered: 'Unanswered',
        }, {
            key: 'Question 2',
            answer: 'Answer',
            unanswered: 'Unanswered',
        },{
            key: 'Question 3',
            answer: 'Answer',
            unanswered: 'Unanswered',
        },{
            key: 'Question 4',
            answer: 'Answer',
            unanswered: 'Unanswered',
        },{
            key: 'Question 5',
            answer: 'Answer',
            unanswered: 'Unanswered',
        },{
            key: 'Question 6',
            answer: 'Answer',
            unanswered: 'Unanswered',
        },{
            key: 'Question 6',
            answer: 'Answer',
            unanswered: 'Unanswered',
        },{
            key: 'Question 6',
            answer: 'Answer',
            unanswered: 'Unanswered',
        },{
            key: 'Question 6',
            answer: 'Answer',
            unanswered: 'Unanswered',
        }];

        const columns = [{
            title: 'Item Number',
            dataIndex: 'key',
            key: 'key',
        }, {
            title: 'Answer Feedback',
            dataIndex: 'answer',
            key: 'answer',
        }, {
            title: 'Result',
            dataIndex: 'unanswered',
            key: 'unanswered',
        }];
        return (
            <div className='box home result'>
                <header>
                    <img src={logo} alt=""/>
                </header>
                <section>
                    <div className='sub_header'>Result</div>
                    <div className='content'>
                        <div className='question_detail'>
                            <h4 style={{fontSize:'17.5px',fontWeight:'bold'}}>ACT Practice Test - English - Timed</h4>
                            <div><span style={{paddingRight:50}}>Number of </span> <span>75</span></div>
                            <div><span>questions </span> <span></span></div>
                            <div><span>Date </span> <span>2019-02-28 05:44</span></div>
                            <div><span>Duration </span> <span>45:00</span></div>
                        </div>
                        <hr/>
                        <div className='complete'>
                            <h3>Your test is complete</h3>
                        </div>
                        <div className='Answer_total'>
                            <h4>Total result</h4>
                            <div className='Answer_box'>
                                <div>Your score </div>
                                <div>0 / 75</div>
                            </div>
                        </div>
                        <h4>Answer Listing</h4>
                        <Table pagination={false} dataSource={dataSource} columns={columns} />
                    </div>
                </section>
                <footer>
                    <div>
                        ©2018-2019 PSI
                    </div>
                </footer>
            </div>
        );
    }
}

export default ViewResult;
